import { motion } from "framer-motion";
import { ReactNode } from "react";

type InputFramerProps = {
  children: ReactNode; // Optional children prop
}

export default function InputFramer({children} : InputFramerProps) {

  const inputVariants = {
    hidden: { opacity: 1, y: 0 },
    visible: { opacity: 1, y: 0 },
  };
  return (
    <motion.div
    variants={inputVariants}
    initial="hidden"
    animate="visible"
    transition={{ duration: 0.4, ease: "easeInOut" }}
  >
        {children}
      </motion.div>
  )
}
